module.exports = __webpack_public_path__ + "img/切割3.3f4d1beb.svg";